import {
    BasicMediathekTeaserProps,
    ComponentType,
    VideoTeaserProps,
    MediathekTeaserProps,
    PortraitTeaserProps,
    PodcastMediathekTeaserProps,
    IconTeaserProps,
} from '@sport1/types/web'
import { FontelloIconType } from '@sport1/news-styleguide/Types'
import {
    getLabelProps,
    getPodcastProps,
    getPortraitProps,
    getVideoProps,
    getIconTeaserProps,
} from './utils'
import { ComponentProps } from '@/types/teaser'
import { takeLastTagWithKeys } from '@/helpers/tagsHelper'
import { publishDateIsCurrentDate } from '@/helpers/dateHelper'
import { MappedTrackingData, useTracking } from '@/utils/tracking/TrackingProvider'

const useGetComponentsProps = (
    teaser: MediathekTeaserProps,
    trackingData: MappedTrackingData,
    backgroundColor?: 'pearl' | 'onyx' | 'TRANSPARENT'
): ComponentProps => {
    const { trackTeaserClick } = useTracking()

    const { tags, publishedAt, title, label, description, imageUrl } =
        teaser as BasicMediathekTeaserProps
    const tag = takeLastTagWithKeys(tags, ['iconUrl', 'title'])
    const defaultProps: ComponentProps = {
        tag: {
            name: tag?.title || '',
            imageUrl: tag?.iconUrl,
            imageAlt: tag?.title,
            iconName: tag?.iconName as FontelloIconType,
        },
        mainImageAlt: description || title,
        published: publishedAt ? publishDateIsCurrentDate(publishedAt) : undefined,
        headlineText: title,
        type: 'VIDEO',
        backgroundColor,
        textColor: backgroundColor === 'onyx' ? 'pearl' : 'onyx',
        onPress: () => trackTeaserClick(trackingData),
        labels: getLabelProps(label),
        mainImageUrl: imageUrl || '',
    }

    switch (teaser.type) {
        case ComponentType.VIDEO_TEASER:
            return { ...defaultProps, ...getVideoProps(teaser as VideoTeaserProps) }
        case ComponentType.PORTRAIT_TEASER:
            return { ...defaultProps, ...getPortraitProps(teaser as PortraitTeaserProps) }
        case ComponentType.PODCAST_TEASER:
            return { ...defaultProps, ...getPodcastProps(teaser as PodcastMediathekTeaserProps) }
        case ComponentType.ICON_TEASER:
            return { ...defaultProps, ...getIconTeaserProps(teaser as IconTeaserProps) }
        default:
            return { ...defaultProps, ...getVideoProps(teaser as VideoTeaserProps) }
    }
}

export default useGetComponentsProps
